<template>
    <div class="list-block">
        <div class="list-block__top-row row">

            <div class="col-md-6 col-12 offset-md-6">
                <sort @orderChange="sortOffers"
                       :hide-desktop="true"
                      :full="true">
                </sort>
            </div>
        </div>
        <div class="row list-block__table-row">
            <div class="col-12">
                <b-table
                    :items="filteredVehicles"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :no-local-sorting="true"
                    :responsive="true"
                    :busy="busy"
                    @sort-changed="sortOffersHeaders"
                    show-empty
                    thead-tr-class="table-header-row"
                    tbody-tr-class="table-row"
                >
                    <template slot="offer" slot-scope="data">
                        <span class="offer" v-if="data.value">Special<br/>Offer</span>
                    </template>
                    <template slot="link" slot-scope="data">
                        <router-link :to="{name: 'details', params: {slug: data.item.slug}}" @click.native="selectVehicle(data)">{{data.item.model | cleanModel(data.item.range) }} {{data.item.variant}} ({{data.item.year | roundYear}})</router-link>
                    </template>
                    <template slot="fuel" slot-scope="data">
                        {{data.value | cleanFuelType}}
                    </template>
                    <template slot="finance" slot-scope="data">
                        {{calculateValue(data.value, data.item.service) | toCurrency}}
                    </template>
                    <template v-slot:empty="scope">
                        <h4 class="text-center">Unfortunately your search did not return any results. Please try modifying your search criteria.</h4>
                    </template>
                    <div slot="table-busy" class="text-center text-danger my-2">
                        <loader-local></loader-local>
                    </div>
                </b-table>
            </div>
        </div>
        <div class="row list-block__pagination" v-if="itemCount > 0">
            <div class="col-12 col-lg-3 pagination-text">
                <span>Showing {{currentVehicles()}} of {{itemCount}} vehicles </span>
            </div>
            <div class="col-12 col-lg-5">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="itemCount"
                        :per-page="itemsPerPage"
                        align="center"
                ></b-pagination>
            </div>
            <div class="col-12 col-lg-4 text-right">
                <div class="row">
                    <div class="col-3">
                        <span class="pagination-text text-right">Show</span>
                    </div>
                    <div class="col-9">
                        <div class="pretty-select">
                            <select id="advance" v-model="itemsPerPage">
                                <option v-for="availableItemPerPage in availablePerPage" :value="availableItemPerPage.value" :key="availableItemPerPage.value">{{availableItemPerPage.text}}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Sort from "./Sort";
    import {FILTER_ORDER, SEARCH_RESULTS_PAGE, SEARCH_RESULTS_PER_PAGE} from "../store/mutation-types";
    import {EXECUTE_FILTER} from "../store/action-types";
    import LoaderLocal from "./LoaderLocal";
    export default {
        name: "List",

        components: {
            LoaderLocal,
            Sort
        },

        data: function() {
            return {
                currentSelectedVehicles: 0,
                sortBy: 'finance',
                sortDesc: false,
                staticServicePart: 3.44, // Update this in src/App/Entity/SearchParams.php as well
                windowWidth: window.innerWidth,
                availablePerPage: [
                    {value: 20, text: '20 vehicles per page'},
                    {value: 30, text: '30 vehicles per page'},
                    {value: 50, text: '50 vehicles per page'},
                ],
                maintLocal: this.maintenance
            }
        },

        methods: {
            sortOffersHeaders: function(ctx) {
                let field = ctx.sortBy,
                    order = (ctx.sortDesc) ? 'desc' : 'asc',
                    orderBy = field + '-' + order;

                this.$store.commit(FILTER_ORDER,orderBy);
                this.$store.dispatch(EXECUTE_FILTER);

            },
            sortOffers: function(order){
                this.$store.commit(FILTER_ORDER,order);
                this.$store.dispatch(EXECUTE_FILTER);
            },
            currentVehicles: function() {
                let start = (this.currentPage * this.itemsPerPage - (this.itemsPerPage));
                let first = start + 1;
                let end = start + this.currentSelectedVehicles;
                return first + ' - ' + end
            },
            executeFilter() {
                let app = this;
                this.$store.dispatch(EXECUTE_FILTER, function () {
                    app.$scrollTo('.list-block');
                });
            },
            selectVehicle(data) {
                let value = [data.item.make, data.item.range, data.item.body, data.item.variant, ('MY' + Math.floor(data.item.year))].join(' ');
                this.$tracking.logStep('View Vehicle', 'SME-Price-List:List:' + value);
            },
            calculateValue(rawValue, service) {
                return (this.maintLocal) ? rawValue + service : rawValue + this.staticServicePart;
            }
        },

        computed: {
            currentPage: {
                get: function() {
                    return this.$store.state.SEARCH_RESULTS_PAGE;
                },
                set: function(value) {
                    this.$store.commit(SEARCH_RESULTS_PAGE, value);
                }
            },
            itemsPerPage: {
                get: function(){
                    return this.$store.state.SEARCH_RESULTS_PER_PAGE;
                },
                set: function(value){
                    this.$store.commit(SEARCH_RESULTS_PER_PAGE, value);
                }
            },
            busy: function(){
                return this.$store.state.SEARCH_BUSY;
            },
            itemCount: function() {
                return this.$store.state.SEARCH_RESULTS_COUNT;
            },
            filteredVehicles: function() {
                return this.$store.state.SEARCH_RESULTS;
            },
            maintenance: function() {
                return this.$store.state.FINANCE_FILTER_MAINT;
            },
            fields: function() {
                let sortable = this.windowWidth > 1199;
                return {
                    make: {
                        label: 'Make',
                        sortable: sortable
                    },
                    range: {
                        label: 'Model',
                        sortable: sortable
                    },
                    link: {
                        label: 'Vehicle',
                        sortable: sortable
                    },
                    offer: {
                        label: 'Offer',
                        sortable: sortable
                    },
                    fuel: {
                        label: 'Fuel',
                        sortable: sortable
                    },
                    transmission: {
                        label: 'Transmission',
                        sortable: sortable
                    },
                    finance: {
                        label: 'Monthly cost',
                        sortable: sortable
                    }
                }
            }
        },

        watch: {
            currentPage: function() {
                this.executeFilter();
            },
            filteredVehicles: function(value) {
                this.currentSelectedVehicles = value.length;
            },
            itemsPerPage: function() {
                this.executeFilter();
            },
            busy: function(value) {
                if(!value) {
                    this.maintLocal = this.maintenance
                }
            }
        },

        mounted() {
            this.currentSelectedVehicles = (this.$store.state.SEARCH_RESULTS !== null && Array.isArray(this.$store.state.SEARCH_RESULTS)) ? this.$store.state.SEARCH_RESULTS.length : 0;
            this.$nextTick(() => {
                window.addEventListener('resize', () => {
                    this.windowWidth = window.innerWidth
                });
            })
        }
    }
</script>

<style lang="stylus">
    .list-block
        &__top-row
            .non-obvious-link-button
                font-family "VWAGTheSansBold",Arial,sans-serif
                border none
                background-color transparent
                font-size 36px
                line-height 44px
                color #004666
            .sow-accordion
                .sow-accordion-panel
                    .sow-accordion-panel-content
                        border-top 1px solid #ecebeb
                    &:last-child
                        border-bottom 1px solid #ecebeb
                        margin-bottom 20px !important
                    .sow-accordion-panel-header
                        cursor pointer
                        .sow-accordion-title
                            color #004666
                            font-size 18px
                            line-height 26px
                            padding 26px 0
                            display flex
                            justify-content space-between
                            font-family: "VWAGTheSansRegular", Arial, sans-serif;

                            .sow-accordion-open-close-button
                                display inline-block
                                position relative
                                height 1px
                                .sow-accordion-button
                                    display inline-block
                                    position absolute
                                    top 10px
                                    right -1px
                                    color #004666
                                    font-size 25px
                                    &__arrow
                                        display inline-block
                                        background url("https://www.vwfsfleet.co.uk/app/themes/vwfs/img/icons/menu-arrow-down.svg") no-repeat #fff 50% 50%
                                        width 40px
                                        height 25px
                                        z-index 10
                                        content ''
                                        &--close
                                            transform: scaleY(-1);
                        &.collapsed
                            .sow-accordion-button--close
                                display none !important

                            .sow-accordion-button--open
                                display inline-block !important

        &__table-row
            .offer
                text-transform uppercase
                font-size 18px
                line-height 28px
                color #a21e4d
                font-family: "VWAGTheSansBold", Arial, sans-serif;
            .table-header-row
                th
                    position relative
                    border-top none !important
                    border-bottom 2px #004666 solid
                    color #004666
                    padding-right 2rem
                    cursor pointer
                    text-align right

                    &:focus
                        outline none

                    @media (max-width 1199px)
                        padding-right .75rem
            .table-row
                td
                    &[aria-colindex="3"]
                        min-width 360px
                    &:last-child
                        text-align right
                        min-width 150px
                    a
                        color #004666
                        font-family: "VWAGTheSansBold", Arial, sans-serif
                        text-decoration underline
                        &:hover
                            text-decoration none
        &__pagination
            margin-top 20px;
            .pagination-text
                text-align left
                display block
                padding-top 7px
                @media (max-width: 960px)
                    text-align center
            .pagination
                .page-item
                    .page-link
                        width 45px
                        height 45px
                        text-align center
                        border-radius 0 !important
                        line-height 32 px
                        font-size 18 px
                        border none
                        color #004666
                    &.active
                        .page-link
                            z-index: 1;
                            color: #fff;
                            background-color: #004666;
                            border none
                    &.disabled
                        .page-link
                            color #dddddd
                    &:selection
                        background: #004666;
                        color: #fff;

</style>